import CheckboxGroup from "./src/index.vue";

CheckboxGroup.install = function (Vue, options) {
  Vue.component(CheckboxGroup.name, CheckboxGroup);
};

export default CheckboxGroup;
